import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import './EmailVerification.scss';

import RCUIClient from '../services/rcui.client';

import RF2CodeSuccessModal from './rf2/CodeSuccessModal';
import RF2CodeRejectModal from './rf2/CodeRejectModal';
import RF2CodeErrorModal from './rf2/CodeErrorModal';

import LMUCodeSuccessModal from './lmu/CodeSuccessModal';
import LMUCodeRejectModal from './lmu/CodeRejectModal';
import LMUCodeErrorModal from './lmu/CodeErrorModal';

import GenericCodeRejectModal from './generic/CodeRejectModal';
import GenericCodeErrorModal from './generic/CodeErrorModal';

import { VerifyEmailRequest, VerifyEmailResponse } from '../models/requests/VerifyEmailRequest';

const EmailVerification = () => {
  
  const [searchParams, setSearchParams] = useSearchParams();

  const [code, setCode] = useState<string>("");
  const [game, setGame] = useState<string>("");

  const [codeSuccessModalShow, setCodeSuccessModalShow] = React.useState(false);
  const [codeRejectModalShow, setCodeRejectModalShow] = React.useState(false);
  const [codeErrorModalShow, setCodeErrorModalShow] = React.useState(false);

  const [emailVerifyRequestInfo, setEmailVerifyRequestInfo] = React.useState<VerifyEmailRequest>();
  const [emailVerifyResponseInfo, setEmailVerifyResponseInfo] = React.useState<VerifyEmailResponse>();
  const [emailErrorResponse, setEmailVerifyResponseError] = React.useState<Error>();

  const rcuiClient = new RCUIClient();

  const showSuccess = (): void => {
    setCodeSuccessModalShow(true);
    setCodeRejectModalShow(false);
    setCodeErrorModalShow(false);
  }

  const showReject = (): void => {
    setCodeSuccessModalShow(false);
    setCodeRejectModalShow(true);
    setCodeErrorModalShow(false);
  }

  const showError = (): void => {
    setCodeSuccessModalShow(false);
    setCodeRejectModalShow(false);
    setCodeErrorModalShow(true);
  }

  useEffect(() => {

    const codeParam = searchParams.get("code");
    if (codeParam != void(0) && codeParam?.length > 0) {
        setCode(codeParam);
    }

    const gameParam = searchParams.get("game");
    if (gameParam != void(0) && gameParam?.length > 0) {
        setGame(gameParam);
    }

    if (codeParam == void(0) || codeParam?.length == 0) return showReject();
    if (gameParam == void(0) || gameParam?.length == 0) return showReject();

    const verifyRequest: VerifyEmailRequest = {
      game: gameParam ?? "rf2",
      uuid: codeParam
    }

    rcuiClient.verifyEmail(verifyRequest)
      .then((res: VerifyEmailResponse) => {
          setEmailVerifyRequestInfo(verifyRequest);
          setEmailVerifyResponseInfo(res);

          return res.Status === "Success" ? showSuccess() : showReject();
      })
      .catch((err: Error) => {
        setEmailVerifyRequestInfo(verifyRequest);
        setEmailVerifyResponseError(err);

        return showError();
      });
    
  }, []);

  return (
    <div className='container-fluid'>
      {
        game === "rf2" ? (
          // rF2-specific modals
          <div className='col-xl'>
            <RF2CodeSuccessModal
              show={codeSuccessModalShow}
              info={emailVerifyResponseInfo}
              res={emailVerifyRequestInfo}
              onHide={() => setCodeSuccessModalShow(false)}
            />
            <RF2CodeRejectModal
              show={codeRejectModalShow}
              info={emailVerifyResponseInfo}
              res={emailVerifyRequestInfo}
              onHide={() => setCodeRejectModalShow(false)}
            />
            <RF2CodeErrorModal
              show={codeErrorModalShow}
              info={emailErrorResponse}
              res={emailVerifyRequestInfo}
              onHide={() => setCodeErrorModalShow(false)}
            />
          </div>
        ) : game === "lmu" ? (
          // LMU-specific modals
          <div className='col-xl'>
            <LMUCodeSuccessModal
              show={codeSuccessModalShow}
              info={emailVerifyResponseInfo}
              res={emailVerifyRequestInfo}
              onHide={() => setCodeSuccessModalShow(false)}
            />
            <LMUCodeRejectModal
              show={codeRejectModalShow}
              info={emailVerifyResponseInfo}
              res={emailVerifyRequestInfo}
              onHide={() => setCodeRejectModalShow(false)}
            />
            <LMUCodeErrorModal
              show={codeErrorModalShow}
              info={emailErrorResponse}
              res={emailVerifyRequestInfo}
              onHide={() => setCodeErrorModalShow(false)}
            />
          </div>
        ) : (
          // Generic error message for malformed links with no game specified
          <div className='col-xl'>
            <GenericCodeRejectModal
              show={codeRejectModalShow}
              info={emailVerifyResponseInfo}
              res={emailVerifyRequestInfo}
              onHide={() => setCodeRejectModalShow(false)}
            />
            <GenericCodeErrorModal
              show={codeErrorModalShow}
              info={emailErrorResponse}
              res={emailVerifyRequestInfo}
              onHide={() => setCodeErrorModalShow(false)}
            />
          </div>
        )
      }
    </div>
  );
};

export default EmailVerification;
